import React, { useState } from "react";
import styled from "styled-components";
import EditSupplier from "./editSupplier";
import { ModalComponent, ModalHeader, ToastMessage } from "components";

const SupplierId = styled.span`
    color: rgba(0, 107, 180, 1);
    font-size: 20px;
    font-weight: 700;
    margin-left: 22px;
`;
const SupplierHeader = styled.span`
    width: 100%;
    font-size: 1.6rem;
    font-weight: 700;
    color: #111827;
`;
function EditSupplierModal({
    showEditSupplierModal,
    selectedSupplierId,
    handleCloseEditSupplierModal,
    setShowEditSupplierModal,
    qaStatus,
}) {
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [supplierName, setSupplierName] = useState(null);
    const onSuccess = (supplierName) => {
        setShowEditSupplierModal(false);
        setSupplierName(supplierName);
        setShowSuccessMessage(true);
    };
    return (
        <>
            <ModalComponent
                open={showEditSupplierModal}
                size="large"
                header={
                    <ModalHeader
                        entityName="Edit Supplier"
                        entityId={selectedSupplierId}
                        entityStatus={qaStatus}
                    />
                }
                borderedHeader
                onClose={handleCloseEditSupplierModal}
            >
                <EditSupplier
                    selectedSupplierId={selectedSupplierId}
                    onClose={handleCloseEditSupplierModal}
                    onSuccess={onSuccess}
                />
            </ModalComponent>
            {showSuccessMessage && (
                <ToastMessage
                    type="success"
                    showToast={showSuccessMessage}
                    setShowToast={setShowSuccessMessage}
                    name={supplierName}
                    text="info edits have been submitted successfully."
                />
            )}
        </>
    );
}

export default EditSupplierModal;
